import { type MutableRefObject, useCallback } from 'react';

import type { Editor as TiptapEditor } from '@tiptap/core';

import { Copy } from '@spotify/confidence-core-react';

import { useCollaborativeDocumentContext } from '../contexts';
import { getDocumentMarkdown } from '../utils';

export const CopyAsMarkdownButton = ({
  editorRef,
}: {
  editorRef?: MutableRefObject<TiptapEditor | null>;
} = {}) => {
  const { collaborativeDocument } = useCollaborativeDocumentContext();

  const getValue = useCallback(
    () =>
      getDocumentMarkdown({
        editor: editorRef?.current,
        markdown: collaborativeDocument?.markdown,
        content: collaborativeDocument?.content,
      }) ?? '',
    [
      editorRef,
      collaborativeDocument?.markdown,
      collaborativeDocument?.content,
    ],
  );

  return <Copy value={getValue} label="Copy as markdown" variant="compact" />;
};
